import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=0a6e784c&scoped=true&"
import script from "./BaseDropdown.vue?vue&type=script&lang=ts&"
export * from "./BaseDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=0a6e784c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6e784c",
  null
  
)

export default component.exports